import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import { ShopRecommendedItemRow } from '@models/item/recommendedItem';
import { useFlow } from '@router/stackflow';

import Badge from './Badge';
import styles from './styles.module.scss';

interface Props {
    shopId: string;
    item: ShopRecommendedItemRow;
}

function RecommendationItem({ item, shopId }:Props) {
  const {
    thumbnailUrl, name, salePrice, shopItemId, badges,
  } = item;
  const { push } = useFlow();
  const handleChangeItem = () => {
    push('ItemActivity', { itemId: shopItemId, shopId });
  };
  return (
        <Row className={styles.container}
             onClick={handleChangeItem}
             spacing={16} >
            <Image src={thumbnailUrl}
                   alt={name}
                   width={96} />
            <Column justify='space-between'
                    fullHeight >
                <Column spacing={4}>
                    <Row spacing={4}>
                        {badges.map((badge, index) => (
                            <Badge key={index.toString()}>{badge}</Badge>
                        ))}
                    </Row>
                    <Text>{name}</Text>
                </Column>
                <Text size='xl' fontWeight='bold'>
                    {salePrice.toLocaleString()}원
                </Text>
            </Column>
        </Row>
  );
}

export default RecommendationItem;
